module.exports = __webpack_public_path__ + "img/play.1f4e1d74.svg";